import { editProfileSchema } from '../../../schema/edit-profile.schema';
import { SubmitForm } from '../../../utils/submit-form.util';
import Container from '../../containers/container';
import Avatar from '../../images/avatar';
import { VStack } from '../../layouts/stack.layout';
import HForm from '../form';
import TextFormGroup from '../inputs/text.formGroup';

const styles = {
  container: 'h-full w-full relative',
  header:
    'mobile:px-2 tablet-lg:px-5 py-3 sticky top-0 z-50 bg-[#08080D]/10 backdrop-blur-sm',
  'avatar-wrapper': 'mask h-fit w-fit mask-squircle p-1 bg-[#121212]',
  footer: 'sticky bottom-0 h-5 z-50 bg-[#08080D]',
};

type EditProfileFormType = {
  displayName: string;
  biography: string;
  location: string;
  spotifyLink?: string;
  appleMusicLink?: string;
  youtubeLink?: string;
  website?: string;
};

type Props = EditProfileFormType & {
  username: string;
  avatar: string;
  bannerUrl: string;
};

export default function EditProfileForm(props: Props) {
  const initialValues = {
    displayName: props.displayName,
    biography: props.biography,
    location: props.location,
    spotifyLink: props.spotifyLink,
    appleMusicLink: props.appleMusicLink,
    youtubeLink: props.youtubeLink,
    website: props.website,
  };
  return (
    <HForm<EditProfileFormType>
      className="relative"
      initialValues={initialValues}
      validationSchema={editProfileSchema}
      onSubmit={(values: any, setSubmitting: Function) =>
        SubmitForm.editProfileFrom(values, setSubmitting)
      }
    >
      <Container extensions="h-[200px] bg-white/[5%] absolute top-0 z-30 left-0 right-0" />
      <Container extensions="h-[200px]">
        <img
          src={props.bannerUrl}
          alt={`${props.username} banner`}
          className="w-full h-full"
          style={{ objectFit: 'cover' }}
        />
      </Container>
      <Container extensions="absolute mt-[-35px] ml-5 z-40">
        <Container extensions={styles['avatar-wrapper']}>
          <Avatar
            url={props.avatar}
            alt={`${props.username} profile`}
            size="base"
          />
        </Container>
      </Container>
      <Container extensions="w-full mt-10 pt-[35px] px-5">
        <VStack gap="base">
          <TextFormGroup name="displayName" type="text" label="display name" />
          <TextFormGroup
            name="biography"
            label="biography"
            type="textarea"
            maxLength={150}
            rows={3}
          />
          <TextFormGroup name="location" type="text" label="location" />
          <TextFormGroup name="spotifyLink" type="text" label="spotify link" />
          <TextFormGroup
            name="appleMusicLink"
            type="text"
            label="apple music link"
          />
          <TextFormGroup name="youtubeLink" type="text" label="youtube link" />
          <TextFormGroup name="website" type="text" label="website" />
        </VStack>
      </Container>
    </HForm>
  );
}
